import ImageIcon from "@mui/icons-material/Image";
import {
  Avatar,
  CheckboxProps,
  Grid,
  Switch,
  Typography
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import { alpha, styled } from "@mui/material/styles";
import { observer } from "mobx-react";
import BasicImage from "pages/MyPage/component/BasicImage";
import { useEffect } from "react";
import EmployeeDetailPageStore from "../store/EmployeeDetailPageStore";

const PinkSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "#2281D0",
    "&:hover": {
      backgroundColor: alpha("#2281D0", theme.palette.action.hoverOpacity),
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#2281D0",
  },
}));

const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  "& .MuiTypography-root": {
    color: "#171918",
    fontFamily: "Pretendard",
    fontWeight: 400,
    fontSize: "13px",
    lineHeight: "13px",
  },
}));

const BpIcon = styled("span")(({ theme }) => ({
  borderRadius: "4px",
  width: 16,
  height: 16,
  backgroundColor: "#000000",
  opacity: "0.1",
  backgroundImage:
    "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
    " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
    "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
    marginRight: "10px",
}));

const BpCheckedIcon = styled(BpIcon)({
  opacity: "1",
  backgroundImage:
    "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
  "&:before": {
    display: "block",
    width: 16,
    height: 16,
    backgroundColor: "#2281D0",
    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
      " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
      "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
    content: '""',
    borderRadius: "4px",
  },
  "input:hover ~ &": {
    backgroundColor: "#106ba3",
  },
  marginRight: "10px",
});

function BpCheckbox(props: CheckboxProps) {
  return (
    <Checkbox
      sx={{
        "&:hover": { bgcolor: "transparent" },
        borderRadius: "4px",
        padding: "4px",
      }}
      disableRipple
      color="default"
      checkedIcon={<BpCheckedIcon />}
      icon={<BpIcon />}
      {...props}
    />
  );
}

interface Props {
  pageStore: EmployeeDetailPageStore;
}
function EmployeeTopIntro(props: Props) {
  const { employee } = props.pageStore;

  const handleChangeCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;

    if (event.target.name === "Email") {
      props.pageStore.setEmailCheck(checked);
      localStorage.setItem("CHECK_ITEM_EMAIL", JSON.stringify(checked));
    } else  if (event.target.name === "Groupware") {
      props.pageStore.setGroupwareCheck(checked);
      localStorage.setItem("CHECK_ITEM_GROUPWARE", JSON.stringify(checked));
    } else if (event.target.name === "Chat") {
      props.pageStore.setChatCheck(checked);
      localStorage.setItem("CHECK_ITEM_CHAT", JSON.stringify(checked));
      if (!checked) {
        props.pageStore.setChatAttachCheckWitoutFilter(false);
        localStorage.setItem("CHECK_ITEM_ATTACH", JSON.stringify(false));
      }
    } else if (event.target.name === "Attach") {
      props.pageStore.setChatAttachCheck(checked);
      localStorage.setItem("CHECK_ITEM_ATTACH", JSON.stringify(checked));
    }
  };

  useEffect(() => {
    const emailCheck = localStorage.getItem("CHECK_ITEM_EMAIL");
    const groupwareCheck = localStorage.getItem("CHECK_ITEM_GROUPWARE");
    const chatCheck = localStorage.getItem("CHECK_ITEM_CHAT");
    const attachCheck = localStorage.getItem("CHECK_ITEM_ATTACH");

    if (emailCheck) {
      props.pageStore.setEmailCheck(JSON.parse(emailCheck));
    }
    if (groupwareCheck) {
      props.pageStore.setGroupwareCheck(JSON.parse(groupwareCheck));
    }
    if (chatCheck) {
      props.pageStore.setChatCheck(JSON.parse(chatCheck));
    }
    if (attachCheck) {
      props.pageStore.setChatAttachCheck(JSON.parse(attachCheck));
    }
  }, []);

  const checkComponent = (
    <FormGroup
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <Grid>
        <Grid>
          <StyledFormControlLabel
            control={
              <BpCheckbox
                checked={props.pageStore.emailCheck}
                onChange={handleChangeCheckbox}
                name="Email"
              />
            }
            label="Email"
          />
        </Grid>
        <Grid style={{ marginTop: "5px" }}>
          <StyledFormControlLabel
            control={
              <BpCheckbox
                checked={props.pageStore.groupwareCheck}
                onChange={handleChangeCheckbox}
                name="Groupware"
              />
            }
            label="Groupware"
          />
        </Grid>
        <Grid style={{ marginTop: "5px" }}>
          <StyledFormControlLabel
            control={
              <BpCheckbox
                checked={props.pageStore.chatCheck}
                onChange={handleChangeCheckbox}
                name="Chat"
              />
            }
            label="Teams"
          />
          {/* <RadioGroup
            row
            aria-labelledby="radiogroup"
            defaultValue={"attach"}
            onChange={handleChagneRadio}
          >
            <StyledFormControlLabel
              control={<Radio style={{ color: "#2281D0" }} />}
              value={"all"}
              label="Teams (All)"
            />
            <StyledFormControlLabel
              control={<Radio style={{ color: "#2281D0" }} />}
              value={"attach"}
              label="Attachments Only"
            />
          </RadioGroup> */}
        </Grid>
        
        <Grid style={{ marginLeft: "10px" }}>
          <FormControlLabel
            control={
              <PinkSwitch
                name="Attach"
                color="primary"
                onChange={handleChangeCheckbox}
                checked={props.pageStore.chatAttachCheck}
                inputProps={{ "aria-label": "controlled" }}
              />
            }
            label={
              <Typography
                style={{
                  color: "#171918",
                  fontFamily: "Pretendard",
                  fontWeight: 400,
                  fontSize: "10px",
                  lineHeight: "10px",
                }}
              >
                Attached
              </Typography>
            }
            labelPlacement="top"
          />
        </Grid>
      </Grid>
    </FormGroup>
  );

  return (
    <Grid
      container
      style={{ padding: "20px 10px 20px 20px" }}
      alignItems={"center"}
      justifyContent={"space-between"}
    >
      <Grid item style={{ display: "flex" }}>
        <Grid>
          {employee?.userData?.profile ? (
            <BasicImage
              src={employee?.userData?.profile}
              style={{
                width: 60,
                height: 60,
                borderRadius: "50%",
                objectFit: "cover",
                overflow: "hidden",
              }}
            />
          ) : (
            <Avatar>
              <ImageIcon />
            </Avatar>
          )}
        </Grid>
        <Grid style={{ marginLeft: "12px" }}>
          <Typography
            style={{
              fontFamily: "Pretendard",
              fontWeight: 600,
              fontSize: "16px",
              lineHeight: "16px",
              marginBottom: "4px",
            }}
          >
            {employee?.userData.deptName}
          </Typography>
          <Grid container>
            <Typography
              style={{
                fontFamily: "Pretendard",
                fontWeight: 500,
                fontSize: "12px",
                lineHeight: "12px",
                color: "#212121",
              }}
            >
              {employee?.names.fullname}
            </Typography>
            <Typography
              style={{
                fontFamily: "Pretendard",
                fontWeight: 400,
                fontSize: "11px",
                lineHeight: "11px",
                color: "#6C6B6F",
                marginLeft: "4px",
              }}
            >
              {employee?.userData.jobTitle}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>{checkComponent}</Grid>
    </Grid>
  );
}

export default observer(EmployeeTopIntro);
